import React, { ReactNode } from 'react'
import { ThemeProvider } from '@leshen/gatsby-theme-leshen'

import 'typeface-montserrat'

interface WrapperProps {
  children: ReactNode
  theme: Record<string, unknown>
}

const Wrapper = ThemeProvider as React.FC<WrapperProps>

export default Wrapper
